import React from "react";

const EnergyLoader = ({ message = "Carregando..." }) => {
  return (
    <div style={{
      position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
      background: "rgba(13, 15, 20, 0.92)",
      display: "flex", flexDirection: "column",
      alignItems: "center", justifyContent: "center",
      zIndex: 99999, backdropFilter: "blur(4px)",
    }}>
      {/* Battery container */}
      <div style={{ position: "relative", width: 80, height: 140 }}>
        {/* Battery tip */}
        <div style={{
          position: "absolute", top: 0, left: "50%", transform: "translateX(-50%)",
          width: 30, height: 8, borderRadius: "4px 4px 0 0",
          background: "#E5A325",
          boxShadow: "0 0 10px rgba(45, 183, 105, 0.4)",
        }} />
        {/* Battery body */}
        <div style={{
          position: "absolute", top: 8, left: 0, right: 0, bottom: 0,
          border: "3px solid #E5A325", borderRadius: 10,
          overflow: "hidden",
          boxShadow: "0 0 20px rgba(45, 183, 105, 0.15), inset 0 0 20px rgba(45, 183, 105, 0.05)",
        }}>
          {/* Fill animation */}
          <div style={{
            position: "absolute", bottom: 0, left: 3, right: 3,
            background: "linear-gradient(180deg, #E5A325, #b8811c)",
            borderRadius: "0 0 6px 6px",
            animation: "batteryFill 2s ease-in-out infinite",
            boxShadow: "0 -4px 15px rgba(45, 183, 105, 0.4)",
          }} />
          {/* Charging lines */}
          <div style={{
            position: "absolute", top: 0, left: 0, right: 0, bottom: 0,
            background: "repeating-linear-gradient(0deg, transparent, transparent 12px, rgba(255,255,255,0.03) 12px, rgba(255,255,255,0.03) 13px)",
          }} />
        </div>
        {/* Bolt icon */}
        <div style={{
          position: "absolute", top: "50%", left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 2, animation: "boltPulse 1.5s ease-in-out infinite",
        }}>
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
            <path d="M13 2L4 14h7l-2 8 9-12h-7l2-8z" fill="#fff" fillOpacity="0.9" stroke="#E5A325" strokeWidth="0.5"/>
          </svg>
        </div>
      </div>

      {/* Text */}
      <p style={{
        marginTop: 24, color: "#E5A325", fontSize: 14,
        fontWeight: 600, letterSpacing: 2, textTransform: "uppercase",
        animation: "textPulse 2s ease-in-out infinite",
      }}>
        {message}
      </p>

      {/* Energy particles */}
      <div style={{ position: "absolute", width: 200, height: 200, pointerEvents: "none" }}>
        {[...Array(6)].map((_, i) => (
          <div key={i} style={{
            position: "absolute",
            width: 4, height: 4, borderRadius: "50%",
            background: "#E5A325",
            left: `${30 + Math.random() * 40}%`,
            animation: `particle ${1.5 + i * 0.3}s ease-in-out infinite ${i * 0.2}s`,
            opacity: 0,
          }} />
        ))}
      </div>

      <style>{`
        @keyframes batteryFill {
          0% { height: 10%; opacity: 0.6; }
          50% { height: 85%; opacity: 1; }
          80% { height: 95%; opacity: 1; }
          100% { height: 10%; opacity: 0.6; }
        }
        @keyframes boltPulse {
          0%, 100% { opacity: 0.7; transform: translate(-50%, -50%) scale(0.9); }
          50% { opacity: 1; transform: translate(-50%, -50%) scale(1.1); }
        }
        @keyframes textPulse {
          0%, 100% { opacity: 0.5; }
          50% { opacity: 1; }
        }
        @keyframes particle {
          0% { transform: translateY(0); opacity: 0; }
          30% { opacity: 0.8; }
          100% { transform: translateY(-120px); opacity: 0; }
        }
      `}</style>
    </div>
  );
};

export default EnergyLoader;
